import * as maplibregl from 'maplibre-gl'
import maplibreWorkerUrl from 'maplibre-gl/dist/maplibre-gl-worker.mjs?url'

// MapLibre GL JS v6 resolves its Web Worker relative to the module URL at runtime.
// When bundled by Vite the worker file is not emitted next to the bundle, so the
// default URL 404s ("Worker failed to load"). Emitting the worker as an asset and
// pointing MapLibre at its real URL fixes the worker initialization.
maplibregl.setWorkerUrl(maplibreWorkerUrl)

export { maplibregl }
export default maplibregl
